import { createFileRoute, useNavigate } from "@tanstack/react-router";
import OrgInfoSection from "@/features/settings/components/OrgInfoSection";
import { useCurrentOrg, useIsOrgAdmin } from "@/stores";

// `onSwitchTab` was a parent-modal callback in admin-nextjs (single
// 4-tab modal). In admin-react each tab is routed, so we forward to the
// matching URL — the router itself owns active-tab state.
const TAB_TO_PATH = {
  general: "/settings/info",
  members: "/settings/members",
  "access-groups": "/settings/access-groups",
} as const;

function SettingsInfoRoute() {
  const org = useCurrentOrg();
  const canEdit = useIsOrgAdmin();
  const navigate = useNavigate();
  if (!org) return null;
  return (
    <OrgInfoSection
      org={org}
      canEdit={canEdit}
      onSwitchTab={(tab) => navigate({ to: TAB_TO_PATH[tab] })}
    />
  );
}

export const Route = createFileRoute("/_admin/settings/info")({
  component: SettingsInfoRoute,
});
